import './global.css';
import App from './components/App.js';

export default App;
